import { Grid, Group, Space } from '@mantine/core';
import { CurrenciesData } from '../../../data/currencies-data.array';
import { MdrFee } from '../../../type/onboard-merchant-request.types';
import { TextInfo } from '../../safe-text/safe-text.component';
import XInfoTabTitle from '../../x-components/x-info-tab-title.component';

interface Props {
  mdrFees: MdrFee[] | undefined;
}

function MerchantDiscountRate(props: Readonly<Props>) {
  const { mdrFees } = props;

  const getMdrFeeTitle = (currencyId: number) => {
    const currency = CurrenciesData.find(
      (currency) => currencyId === parseInt(currency.value)
    );
    return currency?.label;
  };

  return (
    <>
      <Group grow>
        <XInfoTabTitle
          label='Merchant Discount Rate'
          dataCy='merchantDiscountRate'
        />
      </Group>
      <Space h='xl' />
      <Grid>
        {mdrFees?.map((mdrFee) => {
          const title = getMdrFeeTitle(mdrFee.currencyId);
          const currencyId = mdrFee.currencyId;
          const flatRate = mdrFee?.flatRate?.toFixed(2);
          const percentageRate = mdrFee.percentageRate.toFixed(2);

          return (
            <Grid.Col md={3} sm={6} key={currencyId}>
              <TextInfo
                label={title}
                value={`${percentageRate}% ${flatRate ? '+' + flatRate : ''}`}
              />
            </Grid.Col>
          );
        })}
      </Grid>
    </>
  );
}

export default MerchantDiscountRate;
